exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-3717f949] {\r\n    background-color: #fff;\r\n    border-radius: 2px;\n}\n.chart[data-v-3717f949] {\r\n    height: 45vh;\n}\r\n", ""]);

// exports
